const TOKEN_KEY = "token";
const TOKEN_ROLE = "role";
const TOKEN_REFRESH = "token_expires_in";

import Cookies from "js-cookie";

const TokenService = {
    get() {
        return Cookies.get(TOKEN_KEY);
    },
    save(accessToken) {
        Cookies.set(TOKEN_KEY, accessToken, {domain: process.env.COOKIE_DOMAIN});
    },
    remove() {
        Cookies.remove(TOKEN_KEY, {domain: process.env.COOKIE_DOMAIN});
    },
    getRole() {
        return Cookies.get(TOKEN_ROLE);
    },
    saveRole(role) {
        Cookies.set(TOKEN_ROLE, role, {domain: process.env.COOKIE_DOMAIN});
    },
    removeRole() {
        Cookies.remove(TOKEN_ROLE, {domain: process.env.COOKIE_DOMAIN});
    },
    getExpire() {
        return Cookies.get(TOKEN_REFRESH);
    },
    saveExpire(expires_at) {
        Cookies.set(TOKEN_REFRESH, expires_at, {domain: process.env.COOKIE_DOMAIN});
    },
    removeExpire() {
        Cookies.remove(TOKEN_REFRESH);
    },
    removeAll() {
        Cookies.remove(TOKEN_KEY, {domain: process.env.COOKIE_DOMAIN});
        Cookies.remove(TOKEN_ROLE, {domain: process.env.COOKIE_DOMAIN});
        Cookies.remove(TOKEN_REFRESH, {domain: process.env.COOKIE_DOMAIN});
    }
};

export default TokenService;
